import { gql } from "@apollo/client"
import { BenefitsHiringAdvisor } from "@oysterhr/benefits"
import type { BenefitsTier, CountryBenefits } from "@oysterhr/schema"
import type { AdvisorKnowledgeBase } from "../../types"

export type Module = AdvisorKnowledgeBase<
  {
    isoAlpha2Code: string
    countryBenefits: {
      collection: CountryBenefits[]
    }
  },
  {
    salaryCurrencyCode: string
    tier?: BenefitsTier
  }
>

export const queryFragment: Module["queryFragment"] = gql`
  fragment BenefitsPlansQuery on CountryIntelligence {
    isoAlpha2Code
    countryBenefits(perPage: 50, statutory: true) {
      collection {
        benefit
        comment
        countryCode
        tier
      }
    }
  }
`

export const TranslationComponent: Module["TranslationComponent"] = ({ data, input }) => {
  if (!input?.countryCode || !input?.extraInputs || !data?.countryBenefits) {
    throw new Error("No data available for country benefits or tier")
  }
  const { countryCode, extraInputs } = input

  return (
    <BenefitsHiringAdvisor
      countryCode={countryCode}
      tier={extraInputs.tier}
      salaryCurrencyCode={extraInputs.salaryCurrencyCode}
      countryBenefits={data.countryBenefits.collection}
    />
  )
}
